import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import Menu from 'components/filter_dropdown_menu/menu';
const dropdownButtonCss = "dz9wdvv";
export const DropdownButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(dropdownButtonCss, props.className)} />);
const styledButtonContainerCss = "s13on6em";
export const CloseButton = forwardRef(({
  closeDropdown,
  ...props
}, ref) => <div className={styledButtonContainerCss}>
    <Button ref={ref} {...props} onClick={closeDropdown} decoration="secondary-outline" />
  </div>);
const containerIsTabletUpCss = "c142f0da";
const containerHasRightConflictCss = "c61h4nu";
const containerCss = "c1ufhqtg";
export const Container = forwardRef((props, ref) => {
  const {
    hasRightConflict
  } = props;
  const isTabletUp = useDeviceType('isTabletUp');
  const fixedWhen = useDeviceType('isPhone');
  return <FixedContainer ref={ref} {...props} fixedWhen={fixedWhen} className={classNames(containerCss, {
    [containerIsTabletUpCss]: isTabletUp,
    [containerHasRightConflictCss]: hasRightConflict
  }, props.className)} />;
});
const filterHeaderCss = "f1i3hi6m";
export const FilterHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(filterHeaderCss, props.className)} />;
});
const styledMenuCss = "s1o9ec73";
export const StyledMenu = forwardRef((props, ref) => <Menu ref={ref} {...props} className={classNames(styledMenuCss, props.className)} />);
const itemActionsContainerCss = "ikbi5rj";
export const ItemActionsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(itemActionsContainerCss, props.className)} />;
});
const itemsActionButtonCss = "i1w7j9g3";
export const ItemsActionButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(itemsActionButtonCss, props.className)} />);

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");